export default __webpack_public_path__ + "static/latitude-hipster-9a8309ce2ab9c45ea9b7884062d0c301.jpg";